export default {
  ApprovalStatus: {
    SUBMIT: 'Submeter',
    RETRACT: 'Retirar',
    APPROVED: 'Aprovado',
    REJECT: 'Rejeitar',
  },
  ConfigKey: {
    DEFAULT_AVATAR_PATH: 'Caminho do Avatar Padrão',
    KRAMPUS_URL: 'URL do KRAMPUS',
    ADMIN_HOST: 'Endereço da Tela de Administração',
    MIN_DEPOSIT: 'Limite Mínimo de Depósito (Dólares)',
    MIN_WITHDRAWAL: 'Limite Mínimo de Retirada (Dólares)',
    UPLOAD_PATH: 'Diretório Raiz do Sistema para Upload de Arquivos',
    FILE_PATH: 'Subdiretório para Upload de Arquivos',
    REGISTER_URL_BASE: 'URL Base de Registro',
    JWT_VERSION_FRONT: 'Versão JWT do Front',
    JWT_VERSION_ADMIN: 'Versão JWT do Admin',
    MAX_DEPOSIT: 'Valor Máximo de Depósito (Dólares)',
    MAX_WITHDRAWAL: 'Valor Máximo de Retirada (Dólares)',
    SENTRY_ENABLED: 'Sentry Habilitado',
    SENTRY_URL: 'URL do Sentry',
  },
  Currency: {
    USDT: 'USDT',
    BRL: 'Reals',
    INR: 'Rúpia Indiana',
    USD: 'Dólar Americano',
    EUR: 'Euro',
    HKD: 'Dólar de Hong Kong',
    IDR: 'Rupia indonésia',
    VND: 'Dong vietnamita',
  },
  CustomerField: {
    NAME: 'Nome',
    MOBILE: 'Celular',
    SEX: 'Gênero',
    DOB: 'Data de Nascimento',
    DISTRICT: 'Distrito',
  },
  FlowChartType: {
    VERIFIED: 'Fluxo de Autenticação do Cliente',
    DEPOSIT: 'Fluxo de Processamento de Depósito',
    WITHDRAWAL: 'Fluxo de Processamento de Retirada',
  },
  FlowInfoType: {
    VERIFIED: 'Autenticação do Cliente',
    DEPOSIT: 'Processamento de Depósito',
    WITHDRAWAL: 'Processamento de Retirada',
  },
  IdentificationType: {
    ID_CARD: 'Cartão de Identidade',
    PASSPORT: 'Passaporte',
    DRIVER_LICENSE: 'Carteira de Motorista',
    SOCIAL_INSURANCE_CARD: 'Cartão de Seguro Social',
    OTHER: 'Outro',
  },
  ReceiveMethod: {
    BANK: 'Banco',
    USDT: 'USDT',
    NET_PAY: 'Pagamento Online',
  },
  ResourceType: {
    ID: 'Informações de Identidade',
    CUSTOMER_AVATAR: 'Avatar do Cliente',
    IT_RECEIVE_AVATAR: 'Informações de Recebimento da Instituição',
    PROCESS_FLOW: 'Fluxograma',
    TRANSFER_PROOF: 'Comprovante de Transferência',
  },
  Sex: {
    MALE: 'Masculino',
    FEMALE: 'Feminino',
    SECRET: 'Confidencial',
  },
  TransferTransactionStatus: {
    TRANSFERRING: 'Aguardando Transferência',
    TRANSFERRED: 'Transferido',
    CONFIRMED: 'Recebido',
    CANCELLED: 'Cancelado',
    FORCE_CONFIRMED: 'Recebido (Forçado)',
    FORCE_CANCELLED: 'Cancelado (Forçado)',
    FAILED: 'Falha',
  },
  TransferRole: {
    CUSTOMER: 'Cliente',
    IT: 'Instituição',
  },
  DurationType: {
    MINUTES: 'Minutos',
    HOURS: 'Horas',
  },
  Lang: {
    AUTO: 'Automático',
    EN: 'English',
    ZH_CN: '中文（简体）',
    ZH_HK: '中文（繁體）',
    JA: '日本語',
    KO: '한국어',
    PT: 'Português do Brasil',
    ID: 'Indonésio',
  },
  CryptoNetwork: {
    TRC20: 'TRC20',
    ERC20: 'ERC20',
  },
  RoleType: {
    SUPER_USER: 'Super Usuário',
    ROLE_IT: 'Administrador da Instituição',
    ROLE_AGENT: 'Administrador de Agência',
  },
  Country: {
    SOUTH_KOREA: 'Coreia do Sul',
    JAPAN: 'Japão',
    BRAZIL: 'Brasil',
    INDIA: 'Índia',
    TAIWAN: 'Taiwan',
    INDONESIA: 'Indonésia',
    VIETNAM: 'Vietnã',
  },
  QMaxInvestmentOption: {
    HKD_300000: '$300,000',
    HKD_100: '$100',
  },
  QTriggerOption: {
    AT_LATEST_PRICE: 'Minha posição foi fechada com base no preço mais recente disponível',
    STOP_LOSS_NOT_TRIGGERED: 'Stop loss não fechou minha posição',
  },
  AutoCloseOption: {
    INSUFFICIENT_CAPITAL:
      'O mercado está se movendo contra minha posição e minha conta não tem capital suficiente para manter minha posição',
    FAVORABLE_DIRECTION: 'O mercado está se movendo a favor da minha posição',
  },
  QTradingCountOption: {
    COUNT_100: '51 a 100 negociações',
    COUNT_50: '20 a 50 negociações',
    COUNT_LESS_THAN_20: 'Menos de vinte negociações',
    COUNT_NONE: 'Nunca fiz negociações',
  },
  QOtcLeverageOption: {
    BETWEEN_1_50_AND_1_100: 'Entre 1:50 e 1:100',
    BETWEEN_1_25_AND_1_50: 'Entre 1:25 e 1:50',
    BETWEEN_1_2_AND_1_25: 'Entre 1:2 e 1:25',
    NO_LEVERAGE: 'Sem alavancagem (1:1)',
  },
  QFinanceEducationOption: {
    WORKED_IN_FINANCIAL: 'Trabalhei na indústria de serviços financeiros',
    PROFESSIONAL: 'Qualificação profissional/ou educação superior',
  },
  QOccupationOption: {
    EMPLOYEE: 'Empregado',
    SELF_EMPLOYED: 'Trabalhador autônomo',
    RETIRED: 'Aposentado',
    STUDENT: 'Estudante',
    PROPERTY: 'Proprietário',
  },
  QIndustryOption: {
    FINANCIAL_SERVICES: 'Serviços financeiros',
    INFORMATION_TECHNOLOGY: 'Tecnologia da informação',
    HEALTHCARE: 'Saúde',
    RETAIL_AND_CONSUMER_GOODS: 'Varejo e bens de consumo',
    MANUFACTURING: 'Manufatura',
    MEDIA_AND_ENTERTAINMENT: 'Mídia e entretenimento',
    CONSTRUCTION_AND_REAL_ESTATE: 'Construção e imóveis',
    ENERGY_AND_UTILITIES: 'Energia e serviços públicos',
    CONSULTING_AND_PROFESSIONAL_SERVICES: 'Consultoria e serviços profissionais',
    OTHER: 'Outros',
  },
  QFinancialAmountOption: {
    FIVE_M_PLUS: '$5,000,000+',
    FIVE_M: '$2,000,000 - 5,000,000',
    TWO_M: '$1,000,000 - 2,000,000',
    ONE_M: '$500,000 - 1,000,000',
    FIVE_HUNDRED_K: '$200,000 - 500,000',
    TWO_HUNDRED_K: '$50,000 - 200,000',
    FIFTY_K: '$0 - 50,000',
  },
  QIncomeSourceOption: {
    EMPLOYMENT_INCOME: 'Renda de emprego/autônoma',
    PENSION_OR_GOVERNMENT_BENEFITS: 'Pensão ou benefícios do governo',
    INVESTMENT_INCOME: 'Renda de investimentos',
    INHERITANCE: 'Herança',
    PROPERTY_SALE: 'Venda de propriedade',
    BUSINESS_SALE: 'Venda de negócios',
  },
  QTradingFrequencyOption: {
    DAILY: 'Diariamente',
    WEEKLY: 'Semanalmente',
    MONTHLY: 'Mensalmente',
  },
  QDepositMethodOption: {
    CREDIT_CARD: 'Cartão de crédito/cartão de débito',
    BANK_TRANSFER: 'Transferência bancária',
  },
  PaymentGateway: {
    EPAY: 'Pagamento Epay',
    PPAY: 'Pagamento Ppay',
    CASH_PAY: 'Pagamento Cashpay',
    UAT_EPAY: 'UAT Pagamento Epay',
    PRO_EPAY: 'PRO Pagamento Epay',
  },
  PayType: {
    RECEIVE: 'Recarga',
    PAYMENT: 'Retirada',
  },
  TransactionModel: {
    C2C: 'C2C',
    B2C: 'B2C',
    B2B: 'B2B',
    C2B: 'C2B',
  },
  TransactionCategory: {
    BANK: 'Banco',
    TRANSFER: 'Transferência',
    IFSC: 'Pagamentos da Índia-IFSC',
    PIX: 'Pagamento Brasil-PIX',
  },
  FeeModel: {
    FIXED: 'Taxa fixa',
    PERCENTAGE: 'Taxa percentual',
  },
  RateMode: {
    USD_TO_TARGET: 'De USD para a moeda de destino',
    TARGET_TO_USD: 'Da moeda de destino para USD',
  },
  PaymentOrderStatus: {
    FAILED: 'Processamento falhou',
    SUCCESS: 'Processamento bem-sucedido',
    PENDING: 'Processamento pendente',
    CANCELED: 'Processamento cancelado',
    PROCESSING: 'Processamento em andamento',
  },
  DepositPaymentOrderStatus: {
    FAILED: 'Falha na recarga',
    SUCCESS: 'Recarga bem-sucedida',
    PENDING: 'Processamento pendente',
    CANCELED: 'Processamento cancelado',
    PROCESSING: 'Recarregando',
  },
  WithdrawPaymentOrderStatus: {
    FAILED: 'Falha na retirada',
    SUCCESS: 'Retirada com sucesso',
    PENDING: 'Processamento pendente',
    CANCELED: 'Processamento cancelado',
    PROCESSING: 'Retirada em andamento',
  },
  PaySystemOrderStatus: {
    GATEWAY_CREATE: 'GATEWAY_CREATE',
    CONFIRM: 'CONFIRM',
    CANCEL: 'CANCEL',
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
    CLOSE: 'CLOSE',
    FREEZE: 'FREEZE',
    WITHDRAWN: 'WITHDRAWN',
    NO_REFUND_OF_HANDLING_FEE: 'NO_REFUND_OF_HANDLING_FEE',
  },
  ProviderType: {
    GOOGLE: 'Conta do Google',
    FACEBOOK: 'Conta do Facebook',
    APPLE: 'Conta da Apple',
    PASSWORD: 'Senha',
    MAIL_PASSWORD: 'E-mail',
    PHONE_PASSWORD: 'Telefone',
  },
  PaymentChannel: {
    INDIA_UPI_1: 'UPI da Índia - Categoria 1',
    INDIA_NATIVE_1: 'Índia Nativo - Categoria 1',
    INDIA_UPI_2: 'UPI da Índia - Categoria 2',
    INDIA_NATIVE_2: 'Índia Nativo - Categoria 2',
    BRAZIL_PIX_1: 'PIX do Brasil - Categoria 1',
    BRAZIL_PIX_2: 'PIX do Brasil - Categoria 2',
    BRAZIL_PIX_FAST: 'PIX Rápido do Brasil',
  },
  BankInfoExtType: {
    NORMAL: 'NORMAL',
    PIX_EXT: 'PIX_EXT',
    IFSC_EXT: 'IFSC_EXT',
    BANK_EXT: 'BANK_EXT',
    CRYPTO_CURRENCY_EXT: 'CRYPTO_CURRENCY_EXT',
  },
  PixType: {
    CPF: 'Número de identificação pessoal',
    PHONE: 'Número de celular',
    EMAIL: 'Endereço de e-mail',
    EVP: 'Endereço Virtual de Pagamento',
  },
  CryptoTokenType: {
    USDT_ERC20: 'USDT (ERC20)',
    USDT_TRC20: 'USDT (TRC20)',
    USDT_BEP20: 'USDT (BEP20)',
    ETHEREUM: 'Ethereum',
    BNB_BEP20: 'BNB (BEP20)',
    BTC: 'BTC',
    OTF_BEP20: 'OTF (BEP20)',
  },
  EpayCountryCode: {
    BR: 'Brasil',
  },
  EpayGender: {
    MALE: 'Masculino',
    FEMALE: 'Feminino',
  },
  EpayIdType: {
    ID_CARD: 'Cartão de identificação',
    PASSPORT: 'Passaporte',
  },
  EpayPurposeOfRemittance: {
    CorporatePayment: 'Pagamento Corporativo',
    Marketplace: 'Transação de Mercado',
    ProfessionalServices: 'Serviços Profissionais',
    Payroll: 'Pagamento de salário',
    ExpensesReimbursement: 'Reembolso de Despesas',
    RepresentationExpenses: 'Pagamento Empresarial',
    HiredPersonnel: 'Pessoa contratada',
    TraineesScholarships: 'Estagiários/Bolsas',
    ProductivityOrQualityPrizes: 'Prêmios de Produtividade ou Qualidade',
    LayOffPayment: 'Pagamento de dispensa',
    FamilySupport: 'Apoio Familiar',
    Education: 'Educação',
    GiftAndOtherDonations: 'Presentes e outras doações',
    MedicalTreatment: 'Tratamento Médico',
    MaintenanceOrOtherExpenses: 'Manutenção ou outras despesas',
    CarDriver: 'Motorista',
    SoftwareLicense: 'Licença de Software',
    HotelAccommodation: 'Alojamento em Hotel',
    AdvertisingAndOrPublicRelationsRelatedExpenses: 'Despesas relacionadas com publicidade e/ou relações públicas',
    FeesForAdvisoryOrConsultingService: 'Taxas de consultoria ou serviços de consultoria',
    BusinessRelatedInsurancePayment: 'Pagamento de seguro relacionado a negócios',
    InsuranceClaimsPayment: 'Pagamento de sinistros de seguros',
  },
  Gender: {
    MALE: 'Masculino',
    FEMALE: 'Mulher',
    UNKNOWN: 'Desconhecido',
    NOT_APPLICABLE: 'Não_Aplicável',
  },
  BeneficiaryRelationShip: {
    BOYFRIEND: 'Namorado',
    BUSINESS_PARTNER: 'Parceiro de negócios',
    CHILDREN: 'Crianças',
    COLLEAGUE: 'Colega',
    EX_SPOUSE: 'Ex-cônjuge',
    FIANCE: 'Noivo',
    FIANCEES: 'Noivas',
    FRIEND: 'Amigo',
    GIRLFRIEND: 'Namorada',
    GRAND_PARENTS: 'Avós',
    PARENTS: 'Pais',
    RELATIVE_UNCLE_AUNTIE_COUSIN: 'Parente/tio/tia/primo',
    SELF: 'Eu',
    SIBLING_BROTHER_SISTER: 'Irmão/irmão/irmã',
    SPOUSE: 'Cônjuge',
    SUBSIDIARY_COMPANY: 'Empresa subsidiária',
  },
};
